class FirehawkCRMStockDetailModal {
	gridItem = null
  container = null

  modalElement = null
  modal = null
  defaultImage = null

  addingToCart = false

	constructor(gridItem, options) {
		this.gridItem = gridItem

    if (options.container) this.container = options.container
    if (options.defaultImage) this.defaultImage = options.defaultImage
	}

  addListeners() {
    this.modalElement.delegate(".fh-add-to-cart", 'click', (event) => {
      event.preventDefault()
      var current = jQuery(event.currentTarget);
      let stockId = current.data("stock");
      this.addToCart(stockId, current);
    });

    this.modalElement.delegate(".close-modal-btn", "click", (event) => {
      this.closeDetailsModal()
    })

    this.modalElement.on('hidden.bs.modal', (event) => {
      if (this.modal) {
        this.modal.dispose()
      }
      if (this.modalElement) {
        this.modalElement.remove()
      }

      this.modal = null
      this.modalElement = null
    })

    this.modalElement.delegate(".quantity-picker .subtract-button", "click", (event) => {
      let quantityField = jQuery(this.modalElement).find(".quantity-picker #quantity")
      let quantity = quantityField.text()
      if (!quantity) {
        quantity = 1
      } else {
        quantity = +quantity
      }
      if (quantity > 1) {
        quantity -= 1
      }

      quantityField.text(quantity)
    })

    this.modalElement.delegate(".quantity-picker .add-button", "click", (event) => {
      let quantityField = jQuery(this.modalElement).find(".quantity-picker #quantity")
      let quantity = quantityField.text()
      if (!quantity) {
        quantity = 1
      } else {
        quantity = +quantity
      }

      quantity += 1
      quantityField.text(quantity)
    })
  }

  buildModal() {
    let modalContainer = jQuery(`<div class="bs-modal modal fade stock-detail-modal" tabindex="-1" id="stock-detail-${this.gridItem.id}" style="display: none;" aria-hidden="true"></div>`)
		let modal = jQuery('<div class="modal-dialog modal-lg modal-dialog-centered"></div>')
		let modalContent = jQuery('<div class="modal-content">')

    // Setup: Modal body
		let modalBody = jQuery('<div class="modal-body"></div>')

    // Setup: Stock display image
    var displayImage = this.gridItem.displayImage || this.defaultImage
		if (displayImage && displayImage.length) {
			modalBody.append(`<div class="col-12 col-lg-6"><div class="display-image image-basic" style="background-image: url('${displayImage}')"></div></div>`)
		} else {
			modalBody.append('<div class="col-12 col-lg-6"><div class="display-image placeholder image-basic" style="background: #f1f1f1;"></div></div>')
		}

    // Setup: Stock info
    let stockInfo = jQuery('<div class="col-12 col-lg-6 stock-info-col"></div>')
    stockInfo.append(`<h4 class="stock-title mb-0">${this.gridItem.name}</h4>`)
    if (this.gridItem.stockCode) {
      stockInfo.append(`<p class="stock-code">${this.gridItem.stockCode}</p>`)
    }

    if (this.gridItem.description) {
      stockInfo.append(`<p class="stock-description">${this.gridItem.description}</p>`)
    }


    let footer = jQuery('<div class="footer"></div>')

    if (this.gridItem.price) {
      footer.append(`<div class="stock-price"><span>Price:</span><span>${this.gridItem.price}</span></div>`)
    }
    let footerActions = jQuery('<div class="footer-actions"></div>')
		let hideAddToCartButton = true;
		if(!hideAddToCartButton) {
	    footerActions.append(`<div class="input-group quantity-picker">
	      <button class="btn btn-primary subtract-button input-group-prepend" type="button">-</button>
	      <label class="form-control text-center" aria-label="Quantity" id="quantity">1</label>
	      <button class="btn btn-primary add-button input-group-append" type="button">+</button>
	    </div>`)
	    footerActions.append(`<button type="button" class="btn btn-primary fh-add-to-cart" data-stock="${this.gridItem.id}">Add to Cart</button>`)
		}

    footer.append(footerActions)
    stockInfo.append(footer)

    modalBody.append(stockInfo)

    modalContent.append(modalBody)
		modal.append(modalContent)
		modalContainer.append(modal)
		return modalContainer
  }

  show() {
    if (!this.gridItem) return;

    let modalElement = jQuery(this.buildModal())

    if (this.container) {
      jQuery(this.container).append(modalElement)
    } else {
      jQuery("body").append(modalElement)
    }

    this.modalElement = modalElement
		this.modal = new bootstrap.Modal(modalElement.get(0), {})
		this.modal.show()

    this.addListeners()
  }

  hide() {
    this.modal.hide()
  }

  addToCart(stock, currentTarget) {
    if (this.addingToCart) return;
    this.addingToCart = true

    jQuery(currentTarget).addClass("loading")

    let quantityField = jQuery(this.modalElement).find(".quantity-picker #quantity")
    var quantity = quantityField.text() || 1

    var params = {
      stock: stock,
      quantity: quantity
    };

    jQuery.ajax({
      method: 'post',
      url: ajax_var.url,
      data: {
        action: 'add_to_cart',
        params: params
      }
    }).done((response) => {
      if (jQuery(this.modalElement).find(".cart-success").length == 0) {
        jQuery('<div class="bd-callout bd-callout-success cart-success">Item added to cart. <a href="./cart">View Cart</a></div>').prependTo(jQuery(this.modalElement).find(".stock-info-col .footer"))
      }
    }).fail(() => {

    }).always(() => {
      jQuery(currentTarget).removeClass("loading")
      this.addingToCart = false
    })

  }
}
